/* unplugin-vue-components disabled */import { render } from "./Spdex.vue?vue&type=template&id=3966f90a"
import script from "./Spdex.vue?vue&type=script&lang=js"
export * from "./Spdex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__